export default
{
    metryTable:
    {
        totalRows: "Showing {displayedRows} of {rows} rows",
        totalFilteredRows: "Showing {displayedRows} of {rows} filtered rows",
        selectedRows: "{rows} Selected",
        oneSelectedRow: "1 selected",
        tableMenu: "Table Menu",
        columns: "Columns",
        close: "Close",
        noRowsToShow: "No Rows To Show"
    }
}

